module.exports = __webpack_public_path__ + "static/img/23-ai-business.c658788.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-ai-business.png
// module id = eNHY
// module chunks = 1